import { Icon } from "@iconify/react";

function Loading() {
  return (
    <div className="flex items-center text-red-600">
      <Icon icon="eos-icons:loading" className="text-4xl"/>
      <p>در حال بارگذاری</p>
    </div>
  );
}

export default Loading;
